
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Shivajinagartomumbaicab() {



    const cardData =
    {
        keyword: 'Shivajinagar to Mumbai Cab ',
        heading: 'Vedant Travels: Shivajinagar to Mumbai Cab ',
        headingDescription: 'Vedant Travels offers affordable and transparent taxi fares for Shivajinagar to Mumbai travel, ensuring a cost-effective and comfortable journey. Our pricing is competitive, with no hidden charges, and we provide multiple cab options to suit your budget and preferences.',

        top: 'Top Places to Visit in Mumbai with Vedant Travels',

"topPlaces": [
        {
            "title": "Gateway of India",
            "description": "One of Mumbai’s most iconic landmarks, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this magnificent structure is a favorite among tourists for sightseeing and photography. You can also take a ferry from here to visit Elephanta Caves."
        },
        {
            "title": "Marine Drive",
            "description": "Also known as the Queen’s Necklace, Marine Drive is a 3.6 km-long boulevard along the coastline of Mumbai. It’s the perfect spot for an evening stroll, enjoying the sea breeze, or watching the sunset. At night, the streetlights form a stunning arc that resembles a necklace, making it one of the most picturesque locations in Mumbai."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are located on Elephanta Island and feature ancient rock-cut temples dedicated to Lord Shiva. The caves date back to the 5th–7th centuries and are known for their intricate sculptures and carvings. A ferry ride from the Gateway of India takes you to this historical site, offering a blend of nature, history, and spirituality."
        },
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A masterpiece of Victorian Gothic architecture, CSMT is not just a railway station but a UNESCO-listed historic site. The station, formerly known as Victoria Terminus, features grand turrets, stained glass windows, and intricate stone carvings, showcasing the colonial-era grandeur of Mumbai."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of the most revered Hindu temples in Mumbai, Siddhivinayak Temple is dedicated to Lord Ganesha. Thousands of devotees visit the temple daily to seek blessings, including Bollywood celebrities and politicians. The temple’s beautiful architecture and spiritual ambiance make it a must-visit."
        },
        {
            "title": "Juhu Beach",
            "description": "Juhu Beach is among the most famous beaches in Mumbai, known for its lively atmosphere and delicious street food. Whether you want to relax by the sea, take a camel ride, or try local delicacies like pav bhaji, vada pav, and bhel puri, this beach has something for everyone. It's also a popular spot for catching a mesmerizing sunset."
        },
        {
            "title": "Colaba Causeway",
            "description": "If you love shopping, Colaba Causeway is the place to be. This bustling street market is filled with stalls selling jewelry, handicrafts, clothes, antiques, and souvenirs. Besides shopping, you can also explore the charming cafés and restaurants in the area, such as Leopold Café, a historic eatery loved by tourists."
        },
        {
            "title": "Haji Ali Dargah",
            "description": "Situated on a small islet off the coast of Worli, Haji Ali Dargah is a significant religious and architectural landmark in Mumbai. This Indo-Islamic shrine is dedicated to the Sufi saint Haji Ali and is accessible via a narrow causeway that gets submerged during high tide. The dargah’s serene atmosphere and breathtaking views make it a must-visit destination."
        },
        {
            "title": "Bandra-Worli Sea Link",
            "description": "An architectural marvel, the Bandra-Worli Sea Link is an eight-lane bridge that connects South Mumbai to the suburbs. The cable-stayed bridge offers spectacular views of the Arabian Sea and Mumbai’s skyline, especially when illuminated at night. It significantly reduces travel time between Bandra and Worli, making it a vital part of Mumbai’s infrastructure."
        },
        {
            "title": "Bollywood Film City",
            "description": "Mumbai is the heart of the Indian film industry, and Film City in Goregaon offers visitors a chance to witness Bollywood magic up close. With multiple studios, sets, and backdrops, Film City is where countless Bollywood movies and TV shows are filmed. Guided tours provide an exclusive behind-the-scenes look at Mumbai’s thriving cinema industry, making it a must-visit for movie buffs."
        }
    ],


"services": [
    {
        "name": "Shivajinagar to Mumbai Innova Crysta",
        "description": "Travel in comfort and style with our Innova Crysta service from Shivajinagar to Mumbai. Ideal for families and groups, Vedant Travels provides spacious and luxurious rides."
    },
    {
        "name": "Pune Station to Mumbai Cab Service",
        "description": "Book a reliable and timely taxi from Pune Station to Mumbai with Vedant Travels. We offer safe and convenient rides to all parts of Mumbai, including Mumbai Airport."
    },
    {
        "name": "Pune to Mumbai Cab Round Trip",
        "description": "Planning a round trip? Book your Pune to Mumbai round trip with Vedant Travels. Our drivers ensure a comfortable, timely, and affordable journey back and forth."
    },
    {
        "name": "Bundgarden to Mumbai Cab",
        "description": "Travel from Bundgarden to Mumbai with Vedant Travels. We offer punctual and comfortable cab services for your convenience, ensuring a smooth journey."
    },
    {
        "name": "Yerwada to Mumbai Cab Service",
        "description": "Need a taxi from Yerwada to Mumbai? Vedant Travels offers reliable and affordable cab services for a comfortable ride to your destination."
    },
    {
        "name": "Camp to Mumbai Cab Service",
        "description": "Book a taxi from Camp to Mumbai with Vedant Travels. Our services offer a hassle-free journey with well-maintained vehicles and professional drivers."
    },
    {
        "name": "Wakdewadi to Mumbai Cab",
        "description": "Travel from Wakdewadi to Mumbai in comfort and style. Choose Vedant Travels for a safe and timely ride with our experienced drivers."
    },
    {
        "name": "Khadki to Mumbai Cab Service",
        "description": "Book your Khadki to Mumbai cab with Vedant Travels. Whether for business or leisure, we offer reliable and convenient taxi services for your trip."
    },
    {
        "name": "Swargate to Mumbai Cabs",
        "description": "For a comfortable ride from Swargate to Mumbai, book a taxi with Vedant Travels. We offer affordable and professional services to make your journey easy."
    },
    {
        "name": "Pune to Mumbai Ertiga Cab",
        "description": "Travel in comfort with our Ertiga cab service from Pune to Mumbai. Spacious, affordable, and reliable, Vedant Travels provides the best travel experience."
    },
    {
        "name": "Pune to Mumbai Innova Cab",
        "description": "For larger groups or families, choose our Innova cab service from Pune to Mumbai. We ensure a comfortable and hassle-free journey with well-maintained vehicles."
    },
    {
        "name": "Cab Service in Shivaji Nagar Pune",
        "description": "Vedant Travels offers reliable and affordable taxi services in Shivaji Nagar, Pune. Whether it's a ride to the airport, business trip, or leisure, we’ve got you covered."
    },
    {
        "name": "Shivajinagar to Dadar Cab Service",
        "description": "Need a cab from Shivajinagar to Dadar? Choose Vedant Travels for a comfortable ride with professional drivers and punctual service."
    },
    {
        "name": "Shivaji Nagar to Andheri Cab Service",
        "description": "For a smooth ride from Shivaji Nagar to Andheri, book your taxi with Vedant Travels. We provide timely, safe, and affordable rides to Andheri."
    },
    {
        "name": "Pune Station to Mumbai Cab",
        "description": "Looking for a cab from Pune Station to Mumbai? Vedant Travels offers prompt and comfortable rides to your desired location in Mumbai, including the airport."
    },
    {
        "name": "Best Cab Service Pune to Mumbai",
        "description": "Experience the best taxi service from Pune to Mumbai with Vedant Travels. Whether it’s an Innova Crysta, Ertiga, or a sedan, we guarantee a smooth journey."
    },
    {
        "name": "Innova Crysta on Rent in Shivaji Nagar Pune",
        "description": "Rent a Toyota Innova Crysta from Shivaji Nagar, Pune for your trip to Mumbai. Spacious, comfortable, and affordable, the Innova Crysta is ideal for group travel."
    },
    {
        "name": "Ertiga on Rent in Shivaji Nagar",
        "description": "For an economical and comfortable ride, rent an Ertiga from Shivaji Nagar. Vedant Travels offers the best rates for Ertiga rentals for your trip to Mumbai."
    },
    {
        "name": "Contact Information",
        "description": "For bookings and inquiries, contact Vedant Travels at +91 8767459909. We offer reliable, professional, and affordable taxi services for your travel needs from Shivajinagar to Mumbai."
    }
],


"tableData": [
    ["shivajinagar to mumbai innova crysta", "pune station to mumbai cab service"],
    ["pune to mumbai cab round trip", "bundgarden to Mumbai Cab"],
    ["yerwada to mumbai cab service", "camp to mumbai cab service"],
    ["wakdewadi to Mumbai cab", "khadki to mumbai cab service"],
    ["swargate to mumbai cabs", "pune to mumbai ertiga cab"],
    ["Pune to Mumbai Innova Cab", "cab service in shivaji nagar pune"],
    ["shivajinagar to dadar cab service", "shivaji nagar to andheri cab service"],
    ["pune station to mumbai cab", "best cab service pune to mumbai"],
    ["innova crysta on rent in shivaji nagar pune", "ertiga on rent in shivaji nagar"],
    ["Vedant Travels Pune", "Cab service in pune"],
    ["Pune to Mumbai airport cab", "Pune Mumbai Cab"]
],
"whychoose": [
    {
        "WhyChooseheading": "Reliable and On-Time Service",
        "WhyChoosedescription": "At Vedant Travels, we prioritize punctuality. Whether you’re heading to Mumbai for a business trip or a leisure visit, our drivers ensure timely pickups and drop-offs, guaranteeing your journey from Shivajinagar to Mumbai is smooth and on time."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "Enjoy the comfort of our well-maintained and spacious vehicles. From sedans to SUVs, all our cars are equipped with air conditioning and ample legroom, ensuring a pleasant and relaxing ride for the entire journey from Shivajinagar to Mumbai."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are highly trained and experienced, ensuring a safe and efficient trip. They know the best routes for your journey from Shivajinagar to Mumbai, helping you avoid traffic and ensuring a smooth ride."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Vedant Travels offers affordable pricing with no hidden charges. Our transparent pricing model ensures that you know exactly what you’re paying for, with no surprises along the way."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our top priority. All our vehicles are equipped with modern safety features, including airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols to provide you with a secure and comfortable travel experience."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Whether you need a ride early in the morning or late at night, Vedant Travels is available 24/7. You can easily book a cab for your journey from Shivajinagar to Mumbai at any time, with prompt assistance from our customer service team."
    },
    {
        "WhyChooseheading": "Hassle-Free Booking Process",
        "WhyChoosedescription": "Booking a cab for your journey from Shivajinagar to Mumbai is quick and easy. Use our website or mobile app for a seamless booking experience, or get in touch with our customer service team for personalized assistance."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Whether you're traveling for business, leisure, or a special event, we offer customized travel packages that cater to your needs, making your trip from Shivajinagar to Mumbai as comfortable and enjoyable as possible."
    }
]






    








    }


    const faqData = [
        {
            id: 1,
            question: 'How can I book a Shivajinagar to Mumbai cab with Vedant Travels?',
            answer: 'You can book a cab easily through our website or mobile app. Alternatively, you can contact our customer service team for assistance with your booking.',
        },
        {
            id: 2,
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, all our drivers are highly experienced in long-distance travel, including the route from Shivajinagar to Mumbai. They ensure a smooth, safe, and timely journey.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for Shivajinagar to Mumbai travel?',
            answer: 'We offer a variety of vehicles including sedans, SUVs, and luxury cars. All our vehicles are well-maintained, spacious, and equipped with modern amenities for your comfort.',
        },
        {
            id: 4,
            question: 'How do I pay for my Shivajinagar to Mumbai cab rental?',
            answer: 'We accept multiple payment options, including cash, credit/debit cards, and online payments via our app, ensuring convenience and flexibility.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab from Shivajinagar to Mumbai?',
            answer: 'Yes, you can book a round-trip cab. Simply provide your return details when making the booking, and we’ll take care of everything.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any additional charges for waiting time or detours will be communicated to you during the booking process, ensuring full transparency in our pricing.',
        },
        {
            id: 7,
            question: 'Can I hire a cab for sightseeing in Mumbai after my drop-off?',
            answer: 'Yes, we offer sightseeing services in Mumbai. Explore iconic landmarks like the Gateway of India, Marine Drive, and more with a professional driver.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for a Shivajinagar to Mumbai cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have extra luggage or special requirements, please inform us at the time of booking, and we’ll accommodate your needs.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate travel between Shivajinagar and Mumbai?',
            answer: 'Yes, we provide corporate travel services for business meetings, conferences, airport transfers, and more. Contact us for customized corporate packages.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for my Shivajinagar to Mumbai journey?',
            answer: 'Vedant Travels is known for providing reliable, affordable, and comfortable taxi services with professional drivers and well-maintained vehicles. We focus on customer satisfaction, ensuring a seamless and enjoyable journey from Shivajinagar to Mumbai.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Ashish Patil",
            title: "Customer",
            quote: "I booked a cab from Shivajinagar to Mumbai for a business trip. The experience was excellent. The driver was punctual, professional, and the ride was very comfortable. I would definitely recommend Vedant Travels for long-distance trips.",
            rating: 5,
        },
        {
            name: "Mrs. Priya Kulkarni",
            title: "Customer",
            quote: "We used Vedant Travels for a family trip from Shivajinagar to Mumbai. The cab was clean, spacious, and the driver was very polite. We had a smooth journey, and we will definitely book again in the future.",
            rating: 5,
        },
    ];
    










    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Shivajinagar to Mumbai Cab | Vedant Travels",
  "image": "https://www.vedanttravels.in/images/shivajinagar-to-mumbai-cab.jpg",
  "description": "Book your Shivajinagar to Mumbai taxi with Vedant Travels. Comfortable, affordable cabs like Innova Crysta, Ertiga, and Sedan for one-way, airport, and round-trip travel. Reliable drivers, clean vehicles, and timely service.",
  "brand": {
    "@type": "Brand",
    "name": "Vedant Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "reviewCount": "4721",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1399",
    "availability": "https://schema.org/InStock",
    "url": "https://www.vedanttravels.in/shivajinagar-to-mumbai-cab",
    "validFrom": "2025-08-01"
  },
  "areaServed": {
    "@type": "Place",
    "name": [
      "Shivajinagar", "Pune Station", "Swargate", "Camp", "Bund Garden",
      "Yerwada", "Wakdewadi", "Khadki", "Pune", "Mumbai", "Mumbai Airport", "Andheri", "Dadar"
    ]
  }
};




    return (
        <div>
            
     <Helmet>
  <title>Shivajinagar to Mumbai Cab | Vedant Travels</title>
  <meta
    name="description"
    content="Book your Shivajinagar to Mumbai cab with Vedant Travels. One-way, round-trip, and airport transfers in Innova Crysta, Ertiga, and Sedan. Affordable rates and reliable drivers from Pune Station, Camp, and nearby."
  />
  <meta
    name="keywords"
    content="Shivajinagar to Mumbai Cab, Shivajinagar to Dadar Taxi, Pune Station to Mumbai Cab, Camp to Mumbai Taxi, Yerwada to Mumbai Cab, Bund Garden to Mumbai Airport Drop, Innova Cab Shivajinagar to Mumbai, Ertiga Rental Shivaji Nagar, Cab Booking Pune to Mumbai, Vedant Travels"
  />
  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://www.vedanttravels.in/shivajinagar-to-mumbai-cab" />
  <script type="application/ld+json">{JSON.stringify(jsonData)}</script>
</Helmet>

            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/18.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Shivajinagartomumbaicab;